var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1195_7207)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1195_7207",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3.8147e-06H60V60H0V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1195_7207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4926 2.51954L23.5517 15.5787C21.8566 17.2722 19.2361 19.8879 17.0606 22.0519C15.8043 23.3012 15.686 25.2706 16.752 26.6857C18.9997 29.6698 22.309 33.6345 25.1722 36.4977C27.6141 38.9396 30.7538 41.2314 33.6004 43.2485C34.976 44.2232 36.8714 44 38.0601 42.8048C40.0618 40.7925 42.4616 38.3868 44.4801 36.3659L57.5391 49.4249C57.5391 49.4249 55.8061 51.1578 51.2406 55.7235C46.4979 60.4662 37.7785 58.0175 29.1979 52.2588C13.3452 41.62 -4.65753 17.6697 4.10165 8.91047L10.4926 2.51954Z",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3906 5.27344C46.0525 5.27344 54.7266 13.9475 54.7266 24.6094",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3906 12.3047C42.1747 12.3047 47.6953 17.8253 47.6953 24.6094",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3906 19.3359C38.3031 19.3359 40.6641 21.6969 40.6641 24.6094",
    stroke: "#0686D8",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1195_7207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.7006270d2f7a07c48729a4e160e1717f.svg";
export { ForwardRef as ReactComponent };